import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { BaseButton } from "../../../components/button/styled";
import { BaseFieldSet } from "../../../components/formfields/fieldset/styled";
import { BaseInput } from "../../../components/formfields/input/styled";
import { BaseLabel } from "../../../components/formfields/label/styled";
import { BaseLegend } from "../../../components/formfields/legend/styled";
import { AuthLayout } from "../../../containers/layout/auth";
import { LoginFormWrapper } from "./styled";
import { signInUser } from "../../../utils/apis/authentication/signin";
import Cookies from "universal-cookie";

export const Signin = () => {
    const cookies = new Cookies();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [formDetails, setFormDetails] = useState({
        email: "",
        password: "",
    });
    const handleRedirect = (path: string) => {
        return navigate(`${path}`);
    };
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormDetails((prev) => ({
            ...prev,
            [name]: value
        }));
    };
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError(null);
        setIsLoading(true);
        try {
            const response = await signInUser(formDetails);
            if (response.status === "success") {
                setIsLoading(false);
                cookies.set("TOKEN", response.token, {
                    path: "/",
                })
                navigate("/dashboard");
            } else {
                setIsLoading(false);
                setError('Authentication failed. Please check your credentials and try again.');
            }
        } catch (error: any) {
            setIsLoading(false);
            setError(`Login failed. ${error.message}`);
            console.error('Login failed:', error);
        }
    };
    return (
        <AuthLayout>
            <LoginFormWrapper
                onSubmit={handleSubmit}
            >
                <BaseLegend>Login</BaseLegend>
                <BaseFieldSet>
                    <BaseLabel>EMAIL</BaseLabel>
                    <BaseInput
                        required
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        onChange={(e) => handleChange(e)}
                    />
                </BaseFieldSet>
                <BaseFieldSet>
                    <BaseLabel>PASSWORD</BaseLabel>
                    <BaseInput
                        required
                        type="password"
                        name="password"
                        placeholder="Enter your password"
                        onChange={(e) => handleChange(e)}
                    />
                </BaseFieldSet>
                {error && <Typography
                    fontFamily={"Inter"}
                    fontWeight={"600"}
                    fontSize={16}
                    lineHeight={"normal"}
                    color={"#FF0000"}
                    whiteSpace={"normal"}
                >
                    {error}
                </Typography>}
                <Box
                    component={"div"}
                    className="call-to-action"
                >
                    <Typography
                        component={"p"}
                        variant="subtitle1"
                        fontFamily={"Inter"}
                        fontWeight={600}
                        fontSize={16}
                        lineHeight={"normal"}
                        color={"#791377"}
                        marginBlock={"calc(var(--basic-margin)/4)"}
                        textAlign={"right"}
                        sx={{
                            cursor: "pointer",
                        }}
                        onClick={() => handleRedirect("/passwordrecovery/forgotpassword")}
                    >
                        Forgot password?
                    </Typography>
                    <BaseButton
                        type="submit"
                        variant="contained"
                        sx={{
                            width: "100%"
                        }}
                    >
                        {isLoading ? (
                            <CircularProgress color="inherit" className="loader" />
                        ) : (
                            <Typography
                                variant={"button"}
                                fontFamily={"inherit"}
                                fontWeight={"inherit"}
                                fontSize={"inherit"}
                                lineHeight={"inherit"}
                                color={"inherit"}
                                textTransform={"inherit"}
                            >
                                Login
                            </Typography>
                        )}
                    </BaseButton>
                </Box>
            </LoginFormWrapper>
        </AuthLayout>
    )
}